import React, { useEffect, useState } from 'react'

import Color from 'karrierhub-ui/dist/common/src/components/Color'
import Typography from 'karrierhub-ui/dist/common/src/components/Typography'

export function HelperTextComponentForTextArea({
                                                   messages,
                                                   name,
                                                   children,
                                                   value,
                                                   effect,
                                                   changedEver,
                                                   getFocus,
                                                   validation,
                                                   ...props
                                               }) {

    const [_value, setValue] = useState(value)
    const [_, _update] = useState(0)

    useEffect(() => {
        if (effect) {
            effect({
                actions: {
                    setValue,
                    update: async () => _update(Date.now())
                }
            })
        }
        return () => {
            if (effect) {
                effect({
                    actions: {
                        setValue: async () => null,
                        update: async () => null
                    }
                })
            }
        }
    })

    const isError = validation(_value, changedEver.current).error

    const focus = getFocus()

    return (
        <Color
            {...changedEver.current ? { color: isError ? 'error' : undefined } : {}}
        >
            <Typography
                {...props}
            >
                {!changedEver.current || !(_value?.length || 0) || (!focus && !isError) ? children : messages[name + 'CountOfCharacters']({ length: (_value?.length || 0) })}
            </Typography>
        </Color>
    )
}
